import { useFormik } from "formik"
import { useEffect, useRef, useState } from "react"
import Swal from "sweetalert2"
import * as Yup from "yup"
import { getArticuloByCodigo, getSiguienteCodigoArticulo, saveArticulos, saveArticulosCompuestos } from "../../../Services/articuloService"
import { saveError } from "../../../Services/errorService"
import { getAllFamilias } from "../../../Services/familiaService"
import { getAllMarcas } from "../../../Services/marcaService"
import { getAllUnidadMedidas } from "../../../Services/unidadMedidaService"

const useAdd = (history, isSimpleArticle = true) => {
  let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
  let role = token.authorities[0]

  const [itemsCompra, setItemsCompra] = useState([])
  const [isLoad, setIsLoad] = useState(true)
  const [items, setItems] = useState([])
  const [codigoArticulo, setCodigoArticulo] = useState()
  const [cantidadArticulo, setCantidadArticulo] = useState(1)
  const [codigosBarra, setCodigosBarra] = useState([])
  const [familias, setFamilias] = useState([])
  const [marcas, setMarcas] = useState([])
  const [unidadMedidas, setUnidadMedidas] = useState([])
  const inputTotalRef = useRef(null)

  // Funciones comunes:
  const handleCodigosBarra = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      const codigoBarraValue = e.target.value.trim()
      if (codigoBarraValue) {
        let codigoBarra = { codigo: codigoBarraValue }
        setCodigosBarra([...codigosBarra, codigoBarra])
        e.target.value = ''
      }
    }
  }
  const deleteCodigoBarra = (e, codigo) => {
    e.preventDefault()
    let codigosBarraFilter = codigosBarra.filter(function (cv) {
      return cv.codigo !== codigo
    })
    setCodigosBarra(codigosBarraFilter)
  }

  /** Genera un código numérico válido para Code 128 y lo agrega a codigosBarra. */
  const generateAndAddCode128 = () => {
    const makeCode = () => {
      const ts = Date.now().toString().slice(-9)
      const r = Math.floor(Math.random() * 1e4).toString().padStart(4, '0')
      return ts + r
    }
    const code = makeCode()
    setCodigosBarra((prev) => {
      if (prev.some((c) => c.codigo === code)) return prev
      return [...prev, { codigo: code }]
    })
    return code
  }

  // Articulo simple:
  const formikArticle = useFormik({
    initialValues: {
      nombre: '',
      costo: 0.0,
      precioFinal: 0.0,
      puntos: 0,
      codigo: '',
      descripcion: '',
      pesable: false,
      balanza: false,
      pesoPromedio: 0,
      compuesto: false,
      porcentajeGanancia: 0,
      porcentajePerdida: 0,
      familia: '',
      marca: '',
      unidadMedida: '',
    },
    validationSchema: Yup.object({
      nombre: Yup.string().required('Obligatorio'),
      costo: Yup.number().required('Obligatorio').min(0),
      codigo: Yup.string()
        .matches(/^[0-9]+$/, 'Solo números')
        .required('Obligatorio'),
      familia: Yup.object().required('Obligatorio'),
      marca: Yup.object().required('Obligatorio'),
      unidadMedida: Yup.object().required('Obligatorio'),
      porcentajePerdida: Yup.number()
        .min(0, 'Debe ser entre 0 y 100')
        .max(100, 'Debe ser entre 0 y 100'),
    }),
    onSubmit: (values) => addSimpleArticleSubmit(values),
  })
  const addSimpleArticleSubmit = ({
    nombre,
    costo,
    precioFinal,
    puntos,
    codigo,
    descripcion,
    pesable,
    balanza,
    pesoPromedio,
    compuesto,
    porcentajeGanancia,
    porcentajePerdida,
    familia,
    marca,
    unidadMedida,
  }) => {
    const isPesable = String(pesable) === 'true'
    let articulo = {
      nombre,
      costo,
      precioFinal,
      puntos,
      codigo,
      descripcion,
      pesable,
      balanza,
      pesoPromedio,
      compuesto,
      porcentajeGanancia,
      porcentajePerdida: isPesable ? Number(porcentajePerdida) || 0 : 0,
      familiaId: familia.id,
      marcaId: marca.id,
      unidadMedidaId: unidadMedida.id,
      codigosBarra,
    }
    saveArticulos(articulo)
      .then((res) => {
        history.goBack()
      })
      .catch(async (error) => {
        const errorData = {
          mensaje: 'Error al intentar agregar un articulo',
          detalle: error.response.data.message,
          entidad: 'ARTICULO',
          tipo: 'WEBAPP',
          severidad: 'HIGH',
          reportado: 'APPLICATION',
        }
        await saveError(errorData)
        Swal.fire({
          title: 'Faltan datos o algunos son incorrectos.',
          text: error.response.data.message,
          type: 'error',
          showConfirmButton: false,
          timer: 2000,
        })
      })
  }
  useEffect(() => {
    if (role !== 'ROLE_ADMIN') history.goBack()
    if (isLoad) {
      getAllFamilias(true, 0, '', 100)
        .then((res) => setFamilias(res.data.content))
        .catch((err) => console.log('error'))
      getAllMarcas(true, 0, '', 400)
        .then((res) => {
          setMarcas(res.data.content)
        })
        .catch((err) => console.log('error'))
      getAllUnidadMedidas(true, 0, '', 100)
        .then((res) => {
          setUnidadMedidas(res.data.content)
        })
        .catch((err) => console.log('error'))
      setIsLoad(false)

      //Obtener el siguiente codigo del articulo:
      getSiguienteCodigoArticulo()
        .then((res) => {
          const siguienteCodigo = res.data.codigo
          const formik = isSimpleArticle ? formikArticle : formikCompositeArticle;
          formik.setFieldValue('codigo', siguienteCodigo)
        })
        .catch((err) => {
          console.error('Error al obtener código:', err)
        })

    } else {
      setIsLoad(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // Articulo compuesto:
  const formikCompositeArticle = useFormik({
    initialValues: {
      nombre: '',
      costo: 0.0,
      precioFinal: 0.0,
      puntos: 0,
      codigo: '',
      descripcion: '',
      pesable: false,
      balanza: false,
      pesoPromedio: 0,
      compuesto: true,
      porcentajeGanancia: 0,
      porcentajePerdida: 0,
      familia: '',
      marca: '',
      unidadMedida: '',
    },
    validationSchema: Yup.object({
      nombre: Yup.string().required('Obligatorio'),
      costo: Yup.number().required('Obligatorio').min(0),
      codigo: Yup.string()
        .matches(/^[0-9]+$/, 'Solo números')
        .required('Obligatorio'),
      familia: Yup.object().required('Obligatorio'),
      marca: Yup.object().required('Obligatorio'),
      unidadMedida: Yup.object().required('Obligatorio'),
      porcentajePerdida: Yup.number()
        .min(0, 'Debe ser entre 0 y 100')
        .max(100, 'Debe ser entre 0 y 100'),
    }),
    onSubmit: (values) => addCompositeArticleSubmit(values),
  })
  const handleKeyPress = (event) => {
    // codigo y cantidad
    // validar que el articulo no existe en los detalles
    let isPresent = false
    items.forEach((item) => {
      if (parseInt(item.codigo, 10) === parseInt(codigoArticulo, 10))
        isPresent = true
    })
    // si ya se encuentra presento salgo de la funcion
    if (isPresent) {
      setCodigoArticulo('')
      setCantidadArticulo(1)
      inputTotalRef.current.focus()
      Swal.fire({
        toast: true,
        position: 'top',
        title: 'El artículo ya se ingresó.',
        type: 'info',
        showConfirmButton: false,
        timer: 1500,
      })
      return
    }
    getArticuloByCodigo(codigoArticulo)
      .then(async (data) => {
        // datos para calcular precio articulo
        let articulo = data.data
        // items para mostra detalle en pantalla
        let item = {
          id: articulo.id,
          codigo: articulo.codigo,
          articulo: articulo.nombre,
          costo: articulo.costo,
          familia: articulo.familia,
          cantidad: parseFloat(cantidadArticulo, 10),
        }
        // items para guardar en la base de datos
        let itemCompra = {
          id: articulo.id,
          cantidad: item.cantidad,
        }
        // ingresamos items que se guardaran en la bd
        setItemsCompra([...itemsCompra, itemCompra])
        // ingresamos items de  que se mostraran en pantalla
        setItems([...items, item])
        setCodigoArticulo('')
        setCantidadArticulo(1)
        inputTotalRef.current.focus()
      })
      .catch((error) => {
        setCodigoArticulo('')
        setCantidadArticulo(1)
        inputTotalRef.current.focus()
        Swal.fire({
          toast: true,
          position: 'top',
          title: 'El artículo no existe.',
          text: 'No se encontró en la base de datos.',
          type: 'info',
          timer: 2000,
          showConfirmButton: false,
        })
      })
  }
  // elimina items de la lista de articulos
  const deleteItem = (articulo) => {
    let itemsDelete = items.filter((item) => {
      return parseInt(item.id, 10) !== parseInt(articulo.id, 10)
    })
    let itemsCompraDelete = itemsCompra.filter((item) => {
      return parseInt(item.id, 10) !== parseInt(articulo.id, 10)
    })
    setItemsCompra(itemsCompraDelete)
    setItems(itemsDelete)
  }
  const addCompositeArticleSubmit = () => {
    const {
      nombre,
      costo,
      precioFinal,
      puntos,
      codigo,
      descripcion,
      pesable,
      balanza,
      pesoPromedio,
      compuesto,
      porcentajeGanancia,
      porcentajePerdida,
      familia,
      marca,
      unidadMedida,
    } = formikCompositeArticle.values
    const isPesable = String(pesable) === 'true'
    let articulo = {
      nombre,
      costo,
      precioFinal,
      puntos,
      codigo,
      descripcion,
      pesable,
      balanza,
      pesoPromedio,
      compuesto,
      porcentajeGanancia,
      porcentajePerdida: isPesable ? Number(porcentajePerdida) || 0 : 0,
      familiaId: familia.id,
      marcaId: marca.id,
      unidadMedidaId: unidadMedida.id,
      codigosBarra,
      articulos: itemsCompra,
    }
    saveArticulosCompuestos(articulo)
      .then((res) => {
        history.goBack()
      })
      .catch(async (error) => {
        const errorData = {
          mensaje: 'Error al intentar agregar un articulo',
          detalle: error.response.data.message,
          entidad: 'ARTICULO',
          tipo: 'WEBAPP',
          severidad: 'HIGH',
          reportado: 'APPLICATION',
        }
        await saveError(errorData)
        Swal.fire({
          title: 'Faltan datos o algunos son incorrectos.',
          text: error.response.data.message,
          type: 'error',
          showConfirmButton: false,
          timer: 2000,
        })
      })
  }
  return {
    formikArticle,
    itemsCompra,
    setItemsCompra,
    items,
    setItems,
    codigoArticulo,
    setCodigoArticulo,
    cantidadArticulo,
    setCantidadArticulo,
    codigosBarra,
    setCodigosBarra,
    inputTotalRef,
    familias,
    marcas,
    unidadMedidas,
    formikCompositeArticle,
    handleCodigosBarra,
    deleteCodigoBarra,
    generateAndAddCode128,
    handleKeyPress,
    deleteItem,
    addCompositeArticleSubmit
  }
}
export default useAdd